(function () {
	function ready(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			fn();
		}
	}

	function initRoot(root) {
		if (!root || root.dataset.swaOutletsReady === 'true') return;
		root.dataset.swaOutletsReady = 'true';

		var cards = function () { return Array.prototype.slice.call(root.querySelectorAll('[data-outlet-card]')); };
		var globalEmptyEl = root.querySelector('[data-outlets-empty]');
		var exclusiveEmptyEl = root.querySelector('[data-group-empty="exclusive"]');
		var sisEmptyEl = root.querySelector('[data-group-empty="shop_in_shop"]');
		var searchInput = root.querySelector('[data-outlets-search]');
		var cityStrip = root.querySelector('[data-cities-strip]');

		var activeCity = 'all';
		var activeSearch = '';

		function updateEmptyStates() {
			var exclusiveVisible = 0;
			var sisVisible = 0;

			cards().forEach(function (card) {
				var isHidden = card.classList.contains('is-hidden') || card.style.display === 'none';
				if (!isHidden) {
					var cat = card.getAttribute('data-category');
					if (cat === 'shop_in_shop') {
						sisVisible += 1;
					} else {
						exclusiveVisible += 1;
					}
				}
			});

			if (exclusiveEmptyEl) {
				exclusiveEmptyEl.hidden = exclusiveVisible > 0;
			}
			if (sisEmptyEl) {
				sisEmptyEl.hidden = sisVisible > 0;
			}
			if (globalEmptyEl) {
				globalEmptyEl.hidden = (exclusiveVisible + sisVisible) > 0;
			}
		}

		function applyFilters() {
			var q = activeSearch.trim().toLowerCase();
			var tokens = q ? q.split(/\s+/).filter(Boolean) : [];
			// activeCity can hold several cities separated by commas (from ?city=dubai,abu+dhabi)
			var cities = activeCity.toLowerCase().split(',').map(function (c) { return c.trim(); }).filter(Boolean);

			cards().forEach(function (card) {
				var hay = (card.getAttribute('data-search') || '').toLowerCase();
				var cardCity = (card.getAttribute('data-city') || '').toLowerCase();

				var matchSearch = tokens.length === 0 || tokens.every(function (token) {
					return hay.indexOf(token) !== -1;
				});
				var matchCity = activeCity === 'all' || cities.some(function (city) {
					return cardCity.indexOf(city) !== -1 || city.indexOf(cardCity) !== -1;
				});

				var isVisible = matchSearch && matchCity;
				card.classList.toggle('is-hidden', !isVisible);
				card.style.display = isVisible ? '' : 'none';
			});

			updateEmptyStates();
		}

		// Search handler
		if (searchInput) {
			searchInput.addEventListener('input', function (event) {
				activeSearch = event.target.value;
				applyFilters();
			});
			searchInput.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault();
				}
			});
		}

		// City filter handler
		if (cityStrip) {
			cityStrip.addEventListener('click', function (event) {
				var chip = event.target.closest('[data-city-filter]');
				if (!chip) return;

				var isAlreadyActive = chip.classList.contains('is-active');

				// Reset all chips
				cityStrip.querySelectorAll('[data-city-filter]').forEach(function (btn) {
					btn.classList.remove('is-active');
					btn.setAttribute('aria-pressed', 'false');
				});

				if (isAlreadyActive) {
					// Toggle off: show all stores
					activeCity = 'all';
				} else {
					// Select this city
					chip.classList.add('is-active');
					chip.setAttribute('aria-pressed', 'true');
					activeCity = chip.getAttribute('data-city-filter');
				}

				// Clear search when city filter is used
				if (searchInput) {
					searchInput.value = '';
					activeSearch = '';
				}

				applyFilters();
			});
		}

		function updateCityCounts() {
			var allCards = cards();
			var chips = root.querySelectorAll('[data-city-filter]');
			chips.forEach(function (chip) {
				var city = (chip.getAttribute('data-city-filter') || '').toLowerCase().trim();
				var count = 0;
				if (city) {
					allCards.forEach(function (card) {
						var cardSearch = (card.getAttribute('data-search') || '').toLowerCase();
						var cardCity = (card.getAttribute('data-city') || '').toLowerCase();
						if (cardCity.indexOf(city) !== -1 || cardSearch.indexOf(city) !== -1) {
							count++;
						}
					});
				}
				var countEl = chip.querySelector('.swa-city-chip__count');
				var numEl = chip.querySelector('.swa-city-chip__num');
				if (countEl) {
					countEl.textContent = count > 0 ? count + ' Stores' : 'Outlets';
				}
				if (numEl) {
					numEl.textContent = count;
				}
			});
		}

		// Review link click handler
		root.addEventListener('click', function (event) {
			var review = event.target.closest('[data-review-url]');
			if (review) {
				window.open(review.getAttribute('data-review-url'), '_blank');
				return;
			}

			var mediaWrap = event.target.closest('.store-card__media-wrap');
			if (mediaWrap) {
				var card = mediaWrap.closest('.store-card');
				if (card) {
					var isExpanded = card.getAttribute('aria-expanded') === 'true';
					card.setAttribute('aria-expanded', !isExpanded);
				}
			}
		});

		// Preselect cities from the URL, e.g. /pages/outlets?city=dubai,abu+dhabi
		var cityParam = new URLSearchParams(window.location.search).get('city');
		if (cityParam) {
			activeCity = cityParam.toLowerCase();
			var wanted = activeCity.split(',').map(function (c) { return c.trim(); });
			root.querySelectorAll('[data-city-filter]').forEach(function (chip) {
				var isWanted = wanted.indexOf((chip.getAttribute('data-city-filter') || '').trim()) !== -1;
				chip.classList.toggle('is-active', isWanted);
				chip.setAttribute('aria-pressed', isWanted ? 'true' : 'false');
			});
		}

		updateCityCounts();
		applyFilters();
	}

	function initAll(scope) {
		(scope || document).querySelectorAll('[data-swa-outlets]').forEach(initRoot);
	}

	ready(function () { initAll(document); });
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
})();
